// Liens de parrainage (affiliation) par fournisseur, clé = id dans gpu-prices.json.
//
// Vide : les boutons « Rent » pointent vers la page de prix du fournisseur.
// Rempli : ils pointent vers ton lien de parrainage, sont marqués rel="sponsored"
// (exigé par Google pour les liens rémunérés) et la page affiche une mention
// d'affiliation (obligatoire en France comme aux États-Unis).
//
// Exemples, à remplacer par tes vrais codes (RunPod : Settings → Referrals ;
// Vast.ai : Account → Referral) :
//   runpod: "https://runpod.io?ref=TONCODE",
//   vast: "https://cloud.vast.ai/?ref_id=TONID",
export const REFERRAL_LINKS: Partial<Record<string, string>> = {
  runpod: "https://runpod.io?ref=wgctf7kj",
  vast: "https://cloud.vast.ai/?ref_id=729894",
};

export const rentUrl = (o: { id: string; url: string }) => REFERRAL_LINKS[o.id] ?? o.url;
export const rentRel = (o: { id: string }) => (REFERRAL_LINKS[o.id] ? "sponsored noopener noreferrer" : "noopener noreferrer");
